<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="modalContent">
        <div class="confetti-1"></div><div class="confetti-2"></div>
        <div class="tree"></div>
        <div class="modalContentIn">
          <div class="close" v-on:click="close"></div>
          <h4>Leaderboard</h4>
          <div class="loading" v-if="loading"></div>
          <div class="notFound" v-else-if="lb.length < 1">
            <img src="../assets/trophy-black.png">
            <h5>Belum ada data leadborad</h5>
            <p>Periksa kembali lagi nanti</p>
          </div>
          <div class="lbCnt" v-else>
            <div class="lbItem" v-for="(item, i) in lb" :key="i">
              <div class="num">{{(i + 1) + (page * 5)}}</div>
              {{item.name}}<span><b>{{item.point}}</b> poin</span>
              <div class="trophy" v-if="item.point >= 1400"></div>
            </div>
          </div>
          <div class="nav" v-if="!loading">
            <div class="navItem p" v-if="page > 0"
              v-on:click="goBack"></div>
            <div class="navItem n" v-if="canGoNext"
              v-on:click="goNext"></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
      lb: [],
      loading: true,
      page: 0,
      canGoNext: false,
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.show = true;
      this.page = 0;
      this.canGoNext = false;
      this.loading = true;
      this.lb = [];
      this.getData();
    },
    goBack() {
      this.page -= 1;
      this.getData();
    },
    goNext() {
      this.page += 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri(`misc/leaderboard?page=${this.page}`)).then((r) => {
        this.loading = false;
        if (r.data.status !== 200) {
          this.lb = [];
          return;
        }
        this.lb = r.data.data;
        this.canGoNext = r.data.canGoNext;
      });
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 40px 80px;
      border-radius: 5px;
      margin-top: -20px;
      max-width: 400px;
      overflow: hidden;
      background-color: #e6e1c1;
      // background-image: url(../assets/modal-bg2.jpg);
      background-size: auto 100%;
      background-position: left;
      background-repeat: no-repeat;
      width: 380px;
      .tree{
        position: absolute;
        left: 0; right: -10px; bottom: 0; top: 0;
        // background-image: url(../assets/FG-Kanan.svg);
        background-size: auto 120px;
        background-position: right bottom;
        background-repeat: no-repeat;
      }
      .btn{
        position: relative;
        z-index: 9;
        padding: 0 16px;
        font-size: 16px;
        height: 45px;
        line-height: 45px;
        display: inline-block;
        text-decoration: none;
        &:hover{
          color: #fff;
        }
      }
      .cEl{
        position: absolute;
        width: 20px; height: 20px;
        &#el1{
          left: 20px; top: 20px;
        }
        &#el2{
          left: 100px; top: 100px;
        }
        &#el3{
          left: 50%; top: 50%;
        }
        &#el4{
          right: 20px; top: 50px;
        }
        &#el5{
          right: 20px; bottom: 40px;
        }
      }
      .close{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: rgba(0,0,0,.2);
          opacity: .6;
        }
      }
      .notFound{
        background-color: #fff;
        padding: 60px 20px;
        position: relative;
        z-index: 3;
        border-radius: 5px;
        text-align: center;
        img{
          height: 46px;
          margin: 0 0 16px;
          opacity: .65;
        }
        h5{
          font-size: 17px;
          margin: 0 0 2px;
        }
        p{
          margin: 0;
          color: #767676;
          font-size: 15px;
        }
      }
      .loading{
        height: 240px;
        position: relative;
        z-index: 3;
        background-size: 36px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/loading.svg);
      }
      @media (max-width: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 40px 30px;
      }
      img{
        max-width: 100%;
        position: relative;
        z-index: 9;
      }
      h4{
        margin: 0 0 10px;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        position: relative;
        z-index: 3;
      }
      p{
        margin: 0 0 24px;
        font-size: 16px;
        position: relative;
        z-index: 3;
        b{
          color: #5351a4;
          font-family: GolosUIWebBold,sans-serif;
          span{
            color: #f14724;
          }
        }
      }
      button{
        position: relative;
        z-index: 9;
        background: none;
        border: none;
        box-shadow: none;
        font-size: 18px;
      }
      .confetti-1{
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        background-image: url(../assets/confetti-1.png);
        background-position: top center;
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
      .confetti-2{
        position: absolute;
        left: 0; top: 0; right: 0; bottom: -20px;
        background-image: url(../assets/confetti-2.png);
        background-position: bottom center;
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
      .lbCnt{
        position: relative;
        z-index: 3;
        .lbItem{
          box-sizing: border-box;
          padding: 10px 10px 12px;
          padding-left: 70px;
          background-color: #fff;
          border-radius: 5px;
          margin-bottom: 6px;
          position: relative;
          font-size: 17px;
          font-weight: 600;
          padding-right: 50px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          @media (max-width: 680px) {
            padding-left: 65px;
          }
          .num{
            position: absolute;
            left: 14px; top: 11px;
            border-radius: 50%;
            width: 40px; height: 40px;
            text-align: center;
            background-color: #f14724;
            background-color: #fdbb30;
            color: #fff;
            color: #000;
            font-size: 20px;
            box-sizing: border-box;
            padding-top: 6px;
          }
          span{
            display: block;
            font-size: 14px;
            color: #767676;
            font-weight: 400;
            b{
              color: #5351a4;
              font-weight: 600;
            }
          }
          .trophy{
            position: absolute;
            width: 20px; height: 20px;
            background-image: url(../assets/trophy.png);
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
            right: 12px; top: 13px;
          }
        }
      }
      .nav{
        position: relative;
        z-index: 9;
        display: flex;
        justify-content: flex-end;
        .navItem{
          background-color: #fff;
          width: 60px; height: 44px;
          border-radius: 50px;
          margin-left: 5px;
          opacity: .84;
          background-size: 24px auto;
          background-position: center;
          background-repeat: no-repeat;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            opacity: 1;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
          }
          &.n{
            background-image: url(../assets/arrow-next-black.png);
          }
          &.p{
            background-image: url(../assets/arrow-back.png);
          }
        }
      }
    }
  }
</style>
